var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPciLevelCompliant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7212 14.4688H3.28366C1.58054 14.4688 1.50241 15.2969 1.59616 16.3125L3.11179 32.9219C3.20554 33.9375 3.43992 34.7656 5.14304 34.7656H34.8774C36.6118 34.7656 36.8149 33.9375 36.9087 32.9219L38.4243 16.3125C38.5024 15.2969 38.4243 14.4688 36.7212 14.4688ZM35.5024 10.4062C35.2993 9.59375 34.2993 8.9375 33.268 8.9375H20.7055C19.6743 8.9375 18.2524 8.34375 17.5337 7.64062L16.4399 6.5625C15.7212 5.84375 14.2837 5.26562 13.268 5.26562H7.25241C6.23679 5.26562 5.29929 6.09375 5.18991 7.09375L4.65866 11.9062H35.8774L35.5024 10.4062Z",
    fill: "#6D77A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPciLevelCompliant);
export default __webpack_public_path__ + "static/media/PCILevelCompliant.68dc41c7c8cb3a3b9e263595643eba41.svg";
export { ForwardRef as ReactComponent };